import Vue from 'vue'

export default Vue.extend({
  props: ['feature', 'value'],
  computed: {
    valueAccessor: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); },
    },
  },
})
